import React from "react";
import { initialAppData } from "./InitialAppDataContext.d";
import { CountryCode } from "../../utils/CountryCode";
const InitialAppData: initialAppData = {
	locations: [],
	userInformation: {
		country: CountryCode.AU,
		roles: [],
		ipAddress: "",
		didDefaultCountry: false
	},
	uploadLimits: {
		displayRequired: {
			batchLimit: 1000,
			importCSVLimit: 10000
		}
	}
};
export const InitialAppDataContext = React.createContext<initialAppData>(InitialAppData);
